<div
  class="mx-xs-3 user-access-details-default-main d-flex flex-column justify-content-center align-items-center"
>
  <div class="text-container">
    <div class="icon-container ml-auto mr-auto mb-3">
      <img src="assets/svg/ico-user.svg" class="user-icon" />
    </div>
    <div class="text-center mb-4">
      <h2 class="heading">{{ 'USER_PROFILE' | translate }}</h2>
      <p class="empty-box">{{ 'PLEASE_SELECT_A_USER_TO_DISPLAY' | translate }}</p>
    </div>
  </div>
</div>
